import type React from 'react'
import { useTranslation } from 'react-i18next'
import { isPlatformAdmin, useAuth } from '@agion/auth'
import {
  AppSwitcher,
  createAgionAppSwitcherApps,
  getCurrentAgionAppId,
  type AgionAppId,
} from '@agion/ui'

export const InfraUiSwitcher: React.FC<{ collapsed?: boolean }> = ({ collapsed = false }) => {
  const { t } = useTranslation('pages')
  const { user, isAuthenticated } = useAuth()

  if (!isAuthenticated || !isPlatformAdmin(user)) return null

  const appLabels: Record<AgionAppId, string> = {
    admin: t('uiSwitcher.admin', { defaultValue: 'Admin' }),
    control: t('uiSwitcher.control', { defaultValue: 'Control' }),
    app: t('uiSwitcher.app', { defaultValue: 'App' }),
    analytics: t('uiSwitcher.analytics', { defaultValue: 'Analytics' }),
  }

  return (
    <AppSwitcher
      apps={createAgionAppSwitcherApps(appLabels)}
      currentAppId={getCurrentAgionAppId() ?? undefined}
      variant="sidebar"
      collapsed={collapsed}
      labels={{
        selectApp: t('uiSwitcher.title', { defaultValue: 'Applications' }),
        title: t('uiSwitcher.title', { defaultValue: 'Applications' }),
        description: t('uiSwitcher.description', { defaultValue: 'Switch between Agion applications' }),
        tooltip: t('uiSwitcher.tooltip', { defaultValue: 'Switch application' }),
      }}
    />
  )
}
